import policyApi from "~/api/policy";
import propertyApi from "~/api/property";
import policyViewGroupApi from "~/api/policy_view_group";
import NotificationsManager from "../../../mixins/notifications/notifications_manager";

const getPackage = ({
  commit,
  state,
}) => {
  if (state.form.parent_id !== "") {
    policyApi.getById(state.form.parent_id)
      .then((response) => {
        commit("SET_PACKAGE", response.data);
        commit("SET_CORPORATION_ID", state.package?.corporation_id);
      });
  } else {
    commit("SET_PACKAGE", {});
  }
};

const getPolicy = ({
  commit,
  state,
}) => {
  if (!state.policyId) return;
  policyApi.getById(state.policyId)
    .then((response) => {
      commit("SET_POLICY", response.data);
    });
};
const getInitialCreateOrEditPageData = ({
  state,
  commit,
}) => {
  if (!state.customerId) return;
  commit("LOADING_PAGE", true);
  policyApi.initialCreateOrEditPageData(state.customerId)
    .then((response) => {
      commit("SET_INITIAL_CREATE_OR_EDIT_PAGE_DATA", response.data);
      commit("LOADING_PAGE", false);
    });
};
const getViewGroupModel = ({
  commit,
  state,
}) => {
  if (state.form?.view_group_id in state.viewGroupModels) return Promise.resolve();

  return policyViewGroupApi.findById(state.form?.view_group_id)
    .then((response) => {
      commit("SET_VIEW_GROUP_MODEL_BY_ID", {
        id: state.form?.view_group_id,
        model: response.data,
      });
    });
};
const getViewGroups = ({
  state,
  commit,
  getters,
}) => {
  if (!getters.activeBranchId) return;
  if (getters.activeBranchId in state.viewGroups) {
    commit("SET_ACTIVE_BRANCH_ID", getters.activeBranchId);
    return;
  }
  commit("LOADING", true);
  policyApi.getViewGroups(state.customerId, getters.activeBranchId)
    .then((viewGroups) => {
      commit("ADD_VIEW_GROUPS", {
        viewGroups,
        brancheId: getters.activeBranchId,
      });
      commit("SET_ACTIVE_BRANCH_ID", getters.activeBranchId);
      commit("LOADING", false);
    });
};

const getViews = ({
  state,
  commit,
  getters,
}) => {
  commit("LOADING_VIEWS", true);
  if (getters.hasPolicy) {
    policyApi.getViewsForEdit(
      state.customerId,
      state.policyId,
      state.form.view_group_id,
      state.form.policy_view_id,
    )
      .then((response) => {
        Object.values(response)
          .forEach((view) => {
            commit("PUSH_VIEW_TO_FORM", view);
          });
        commit("SET_VIEWS", response);
        commit("LOADING_VIEWS", false);
      });
  } else {
    // When editing.
    policyApi.getViews(
      state.customerId,
      state.form.view_group_id,
      state.form.policy_view_id,
    )
      .then((response) => {
        Object.values(response)
          .forEach((view) => {
            commit("PUSH_VIEW_TO_FORM", view);
          });
        commit("SET_VIEWS", response);
        commit("LOADING_VIEWS", false);
      });
  }
};

const getViewOptions = ({
  state,
  commit,
}) => {
  if (state.form.view_group_id in state.viewOptions) return;
  commit("LOADING", true);
  policyApi.getViewOptions(state.form.view_group_id)
    .then((viewOptions) => {
      commit("SET_VIEW_OPTIONS", viewOptions);
      commit("LOADING", false);
    });
};

const savePolicy = ({
  getters,
  commit,
  state,
}) => {
  if (getters.hasPolicy) {
    // Updating an existing policy
    policyApi.updatePolicy(state.form, state.policyId, state.customerId)
      .then((response) => {
        NotificationsManager.success(response);
        commit("SET_SAVED_AT");
      })
      .catch((error) => NotificationsManager.error(error))
      .finally(() => {
        commit("SET_LOADING_RESPONSE", false);
      });
  } else if (getters.isSinglePolicy) {
    // Storing a new single policy.
    policyApi.storeSinglePolicy(state.form, state.customerId)
      .then((response) => {
        NotificationsManager.success(response);
      })
      .catch((error) => NotificationsManager.error(error));
  } else {
    // Storing a new policy with a parent
    policyApi.storePolicy(state.form, state.customerId, state.packageId)
      .then((response) => {
        NotificationsManager.success(response);
      })
      .catch((error) => NotificationsManager.error(error));
  }
};

const fillVehicleDataFields = ({
  state,
  commit,
}, vehicleData) => {
  state.form?.views.forEach((view, viewIndex) => {
    Object.values(view.inputs)
      ?.forEach((renderableInput) => {
        if (renderableInput.code in vehicleData) {
          commit("SET_FORM_VIEW_FIELD_VALUE", {
            catalogId: renderableInput.catalog_id,
            viewIndex,
            value: vehicleData[renderableInput.code],
          });
        }
      });
  });
};

const autofillAddress = ({
  state,
  commit,
}, postalCode, houseNumber = null, viewUuid) => {
  propertyApi.autofill(
    postalCode,
    houseNumber?.toString(),
  )
    .then((response) => {
      state.form?.views.forEach((view, viewIndex) => {
        if (view.uuid === viewUuid) {
          Object.values(view.inputs)
            ?.forEach((renderableInput) => {
              let prefilledValue = null;
              // eslint-disable-next-line default-case
              switch (renderableInput.code) {
                case "PLAATS":
                  prefilledValue = response.data.city;
                  break;
                case "STRAAT":
                  prefilledValue = response.data.street;
                  break;
              }
              if (prefilledValue === null) return;
              commit("SET_FORM_VIEW_FIELD_VALUE", {
                catalogId: renderableInput.catalog_id,
                viewIndex,
                value: prefilledValue,
              });
            });
        }
      });
    });
};
const suggestAddressDataFields = ({
  state,
  commit,
},
viewUuid) => {
  const view = state.form?.views.find((v) => v.uuid === viewUuid);

  if (!view) return;

  // When creating a new policy or adding a new coverage the inputs are not an array
  // This is a workaround to get access to the filter function
  if (view.inputs.constructor !== Array) {
    view.inputs = Object.entries(view.inputs).map(([, input]) => input);
  }

  const postalCode = view.inputs.find((input) => (input.code === "PCODE")) || null;

  const houseNumber = view.inputs.find((input) => (input.code === "HUISNR")) || null;

  if (postalCode !== null
    && houseNumber !== null
    && postalCode.attributes.value.length >= 6) {
    // TODO: Add a debounce to this function.
    autofillAddress({
      state,
      commit,
    }, postalCode.attributes.value, houseNumber.attributes.value, viewUuid);
  }
};
const setPolicyGroupKey = ({
  commit,
  dispatch,
}, {
  value,
  field,
}) => {
  commit("SET_NEW_POLICY_GROUP_KEY", {
    value,
    field,
  });
  if (field.code === "PCODE" || field.code === "HUISNR") {
    dispatch("suggestAddressDataFields", {
      field,
      value,
    });
  }
};

const deleteCoverage = ({
  state,
  commit,
  getters,
}, uuid) => {
  const views = { ...state.form.views };
  const viewToDelete = Object.values(views)
    .filter((view) => view.uuid === uuid)[0];
  const isRequired = Object.values(getters.requiredViews)
    .filter(
      (view) => (view.id || view.view_id) === viewToDelete.view_id,
    ).length > 0;
  const coveragesOfSameView = Object.values(views)
    .filter(
      (view) => (view.id || view.view_id) === viewToDelete.view_id,
    );
  const requiredCoveragesOfSameView = Object.values(getters.requiredViews)
    .filter(
      (view) => (view.id || view.view_id) === viewToDelete.view_id,
    );

  // delete the view if not required or not the last required view
  if (!isRequired || coveragesOfSameView.length > 1 || requiredCoveragesOfSameView.length > 1) {
    commit("DELETE_VIEW", uuid);
  }
};

export default {
  getViewGroupModel,
  setPolicyGroupKey,
  fillVehicleDataFields,
  suggestAddressDataFields,
  getPolicy,
  getPackage,
  savePolicy,
  getInitialCreateOrEditPageData,
  getViews,
  getViewGroups,
  getViewOptions,
  deleteCoverage,
};
